module.exports = __webpack_public_path__ + "static/map_usa_NE_mobile-5c268f2d82cdddfc3173df38e2a8ac05.png";